import React from "react";
import { connect } from "react-redux";
import config from "../../config/config";
import { withRouter } from "react-router";
import { EntryLoader } from "../../components/loader";
import { LayoutForNoting } from "../../components/layout";
import Cookies from "js-cookie";
import { sessionKeeper } from "@cores/sessionKeeper";
import { siteMode } from "@cores/siteMode";

// Pops launcher에서 앱을 클릭해서 들어오게 될 때 호출되는 페이지

class LoginRedirection extends React.Component {
    componentDidMount() {
        const currentSiteMode = siteMode.get();
        const targetPath = currentSiteMode === "CONSOLE" ? "/spaces" : "/library/spaces";
        const domain = sessionKeeper.getDomain();
        Cookies.set("beforeLogin", targetPath, {
            expires: 1,
            path: "/",
            domain,
        });
        const redirectUrl = `${window.location.origin}${config.host.loginRedirectUri}`;
        const loginUrl = window.location.origin.indexOf('designhub.lxhausys.com') > -1 ? "https://login.designhub.lxhausys.com" : config.mz_pops.oauth_host;
        window.location.href = `${loginUrl}/oauth/authorize?response_type=code&client_id=${config.mz_pops.clientId}&redirect_uri=${redirectUrl}`;
    }

    render() {
        return (
            <LayoutForNoting>
                <EntryLoader />
            </LayoutForNoting>
        );
    }
}

let mapStateToProps = (state) => {
    return {};
};
let mapDispatchToProps = (dispatch) => {
    return {};
};

LoginRedirection = connect(mapStateToProps, mapDispatchToProps)(LoginRedirection);
export default withRouter(LoginRedirection);
